import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { footerContent, navLinks } from '../mock';
import PinarLogo from './PinarLogo';

const Footer = () => {
  const f = footerContent;
  return (
    <footer className="bg-[#15294A] text-white/70">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center h-12 w-12 shrink-0">
              <PinarLogo size={48} />
            </span>
            <div className="leading-tight">
              <div className="font-serif text-[14px] font-semibold tracking-[0.16em] text-white">
                PINAR ENGLISH
              </div>
              <div className="font-serif text-[9px] tracking-[0.32em] text-[#E8B84A] mt-0.5">
                A C A D E M Y
              </div>
            </div>
          </div>
          <p className="mt-4 font-serif italic text-[18px] text-[#E8B84A]">
            {f.tagline}
          </p>
          <p className="mt-3 text-[13px] text-white/60 max-w-xs">
            {f.meta}
          </p>
        </div>

        <div>
          <div className="text-[11px] font-semibold tracking-widest text-[#E8B84A] uppercase">
            Navegación
          </div>
          <ul className="mt-4 space-y-2 text-[13px]">
            {navLinks.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="hover:text-[#E8B84A] transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] font-semibold tracking-widest text-[#E8B84A] uppercase">
            Seguínos
          </div>
          <ul className="mt-4 space-y-2 text-[13px]">
            <li className="flex items-center gap-2">
              <Instagram className="h-4 w-4 text-[#E8B84A]" />
              <a href="#" className="hover:text-[#E8B84A] transition-colors">
                @pinar.english
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Facebook className="h-4 w-4 text-[#E8B84A]" />
              <a href="#" className="hover:text-[#E8B84A] transition-colors">
                Pinar English Academy
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-[11px] text-white/50">
          <div>{f.legal}</div>
          <div className="font-serif italic text-[#E8B84A]/80">Learn it. Speak it.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
